
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 22,
  viewBox: "0 0 23 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m10.543 19.128-5.096 2.779a.7.7 0 0 1-1.023-.744l1.068-5.704a2 2 0 0 0-.592-1.821L.683 9.65a.7.7 0 0 1 .391-1.203L6.829 7.7a2 2 0 0 0 1.55-1.125l2.489-5.243a.7.7 0 0 1 1.264 0l2.49 5.243A2 2 0 0 0 16.17 7.7l5.755.747a.7.7 0 0 1 .39 1.203L18.1 13.638a2 2 0 0 0-.592 1.82l1.068 5.705a.7.7 0 0 1-1.023.744l-5.096-2.779a2 2 0 0 0-1.914 0z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "evenodd"
})));

      const __svgRaw = "<svg width=\"23\" height=\"22\" viewBox=\"0 0 23 22\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"m10.543 19.128-5.096 2.779a.7.7 0 0 1-1.023-.744l1.068-5.704a2 2 0 0 0-.592-1.821L.683 9.65a.7.7 0 0 1 .391-1.203L6.829 7.7a2 2 0 0 0 1.55-1.125l2.489-5.243a.7.7 0 0 1 1.264 0l2.49 5.243A2 2 0 0 0 16.17 7.7l5.755.747a.7.7 0 0 1 .39 1.203L18.1 13.638a2 2 0 0 0-.592 1.82l1.068 5.705a.7.7 0 0 1-1.023.744l-5.096-2.779a2 2 0 0 0-1.914 0z\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"evenodd\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/star.083b11a9331e4cac8f356571da95c9c8.svg"),
        {
          React: SvgStar,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      